export enum PaginationMode {
  Client = 'CLIENT',
  Server = 'SERVER'
}
